import React, { useCallback, useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import { updatePost, loadPost } from "../../../../redux/modules/postSlice";
import { ConfirmModal, AlertModal } from "../MoreComponent";

import { DetailLine } from "../common/commonStyle";
import {
  Container,
  CreateHead,
  ArrowBack,
  SelectCategory,
  CategoryList,
  WritingPost,
  TextareaCreatePost,
  Attach,
  Registration,
  BottomFixed,
} from "./UpdatePostStyle";

function UpdatePost() {
  const textRef = useRef();
  const inputRef = useRef();
  const dispatch = useDispatch();

  const [commentLength, setCommentLength] = useState(0);
  const [selectCategory, setSelectCategory] = useState(false);
  const [goBackModal, setGoBackModal] = useState(false);
  const [alertModal1, setAlertModal1] = useState(false);
  const [alertModal2, setAlertModal2] = useState(false);
  const [alertModal3, setAlertModal3] = useState(false);

  const mainPosts = useSelector((state) => state.post.mainPosts);
  const { boardId } = useParams();
  const post = mainPosts.filter(
    (v) => parseInt(v.boardId) === parseInt(boardId),
  )[0];
  const categoryArray = useSelector((state) => state.post.categoryArray).filter(
    (el) => el !== "전체", // 카테고리목록중 '전체'를 뺀 나머지 배열
  );

  const [text, setText] = useState("");
  const [category, setCategory] = useState(post.category);

  // const [originPreViewImgs, setOriginPreViewImgs] = useState(post.images); // 클라
  // const [originShowImages, setOriginShowImages] = useState(post.images); // 서버
  const [preViewImgs, setPreViewImgs] = useState(post.images); // 클라
  const [showImages, setShowImages] = useState(post.images); // 서버

  // file 이미지 미리보기
  const handleAddImages = (e) => {
    const imageLists = e.target.files;

    let imageUrlLists = [...showImages]; // 서버
    let previewUrlLists = [...preViewImgs]; //클라

    for (let i = 0; i < imageLists.length; i++) {
      // 서버
      const currentImageUrl = imageLists[i];
      imageUrlLists.push(currentImageUrl);

      // 클라
      const previewCurrentImageUrl = URL.createObjectURL(imageLists[i]);
      previewUrlLists.push(previewCurrentImageUrl);
    }

    if (imageUrlLists.length > 5) {
      imageUrlLists = imageUrlLists.slice(0, 5); // 서버
      previewUrlLists = previewUrlLists.slice(0, 5); //클라
    }

    setShowImages(imageUrlLists);
    setPreViewImgs(previewUrlLists);
  };

  // X버튼 클릭 시 이미지 삭제
  const handleDeleteImage = (image, i) => {
    const deleteImage = showImages.filter(
      (el, showImgIndex) => showImgIndex === i,
    )[0]; // 서버
    const deletePreviewImage = preViewImgs.filter((el) => el === image)[0]; //클라

    URL.revokeObjectURL(deletePreviewImage); // 클라
    setShowImages(showImages.filter((el) => el !== deleteImage));
    setPreViewImgs(preViewImgs.filter((el) => el !== deletePreviewImage));
  };

  const onClickCategoryArrow = useCallback(() => {
    setSelectCategory((prev) => !prev);
  }, []);

  const onClickWritingPost = useCallback(() => {
    textRef.current.focus();
  }, []);

  useEffect(() => {
    setText(post.content);
  }, [post.content]);

  const onChangeText = useCallback((e) => {
    setText(e.target.value);
    setCommentLength(e.target.value.length);
  }, []);

  const onClickCategory = useCallback((el) => {
    setCategory(el);
    setSelectCategory((prev) => !prev);
  }, []);

  // 게시글 수정
  const navigate = useNavigate();
  const onClickRegister = useCallback(() => {
    const payload = {
      navigate,
      boardId: post.boardId,
      content: text,
      category: category,
      images: showImages,
    };
    dispatch(updatePost(payload))
      .unwrap()
      .then((res) => {
        console.log(res);
        navigate(`/boards/${post.boardId}`, { replace: true });
      });
  }, [dispatch, navigate, text, category, showImages, post.boardId]);

  // 뒤로가기 - props전달할것들
  const query = "작성을 종료하시겠습니까?";
  const notice = "작성하신 내용이 저장되지 않습니다.";
  const onClickCancel = () => {
    setGoBackModal(false);
  };
  const onClickConfirm = () => {
    setGoBackModal(false);
    navigate(-1);
  };
  // 뒤로가기
  const goBack = useCallback(() => {
    setGoBackModal(true);
  }, []);

  // 등록오류케이스
  const onClickAlertToggle1 = useCallback(() => {
    setAlertModal1(true);
  }, []);
  const onClickAlertToggle2 = useCallback(() => {
    setAlertModal2(true);
  }, []);
  const onClickAlertToggle3 = useCallback(() => {
    setAlertModal3(true);
  }, []);
  // 등록오류케이스 props전달값
  const onClickAlert1 = () => {
    setAlertModal1(false);
  };
  const onClickAlert2 = () => {
    setAlertModal2(false);
  };
  const onClickAlert3 = () => {
    setAlertModal3(false);
  };
  const textLength = "내용을 10자 이상 작성해 주세요.";
  const categoryNone = "게시글의 주제를 선택해 주세요.";
  const bothCase = `게시글 주제를 선택하고, 
  내용을 10자 이상 작성해 주세요`;

  return (
    <Container>
      <CreateHead>
        <ArrowBack onClick={goBack} src="/img/arrowBack.svg" alt="arrow back" />
        <h1>글 수정하기</h1>
      </CreateHead>
      {goBackModal && (
        <ConfirmModal
          query={query}
          notice={notice}
          onClickCancel={onClickCancel}
          onClickConfirm={onClickConfirm}
        />
      )}
      <DetailLine />

      <SelectCategory onClick={onClickCategoryArrow}>
        <>
          {category ? ( // 카테고리 선택 여부
            <h2>{category}</h2>
          ) : (
            <h2>게시글의 주제를 선택해 주세요</h2>
          )}
          {selectCategory ? ( // 카테고리 목록 토글
            <img src="/img/listArrowUp.svg" alt="close list" />
          ) : (
            <img src="/img/arrowMore.svg" alt="more arrow" />
          )}
        </>
      </SelectCategory>

      <DetailLine />
      {selectCategory ? ( // 카테고리 목록 토글
        <>
          <CategoryList>
            <div>
              <span>주제목록</span>
            </div>
            <ul>
              {categoryArray.map((el) => (
                <li key={el} onClick={() => onClickCategory(el)}>
                  {el}
                </li>
              ))}
            </ul>
          </CategoryList>
        </>
      ) : (
        <>
          <WritingPost onClick={onClickWritingPost}>
            <TextareaCreatePost
              ref={textRef}
              value={text}
              onChange={onChangeText}
              minlength="10"
              autoFocus
              placeholder="이곳에 내용을 작성해 주세요. (최소 10자 이상 작성해 주세요.)"
            />
          </WritingPost>

          <BottomFixed>
            <Attach>
              {/* 사진 파일 첨부 */}
              <input
                ref={inputRef}
                type="file"
                multiple="multiple"
                accept="image/*, video/*"
                style={{ display: "none" }}
                onChange={(e) => handleAddImages(e)}
                formEncType="multipart/form-data"
              />
              <div
                className="imgAddBtn"
                onClick={() => {
                  inputRef.current.click();
                }}
              >
                {showImages.length === 0 ? (
                  <>
                    <img
                      className="gray"
                      src="/img/cameraImg0.svg"
                      alt="이미지 추가 버튼"
                    />
                    <div className="gray">{showImages.length}/5</div>
                  </>
                ) : (
                  <>
                    <img src="/img/cameraImg.svg" alt="이미지 추가 버튼" />
                    <div>
                      <span>{showImages.length}</span>/5
                    </div>
                  </>
                )}
              </div>

              {/* 이미지 미리보기 */}
              {preViewImgs.map((image, i) => (
                <div className="imageContainer" key={image + i}>
                  <img
                    className="imageDelete"
                    src="/img/imgDel.svg"
                    alt="이미지 삭제"
                    onClick={() => handleDeleteImage(image, i)}
                  />
                  <img className="image" src={image} alt="이미지 미리보기" />
                </div>
              ))}
            </Attach>

            {/* 등록하기 */}
            <Registration>
              {category ? (
                text.length > 9 ? (
                  <div className="possible" onClick={onClickRegister}>
                    <div>등록하기</div>
                  </div>
                ) : (
                  // 카테고리는 선택, 글자수 10미만인 경우 textLength
                  <div className="impossible">
                    <div onClick={onClickAlertToggle1}>등록하기</div>
                  </div>
                )
              ) : text.length > 9 ? ( // 카테고리만 선택안한 경우
                <div className="impossible">
                  {/* <div onClick={onClickAlertToggle}>등록하기</div> */}
                  <div onClick={onClickAlertToggle2}>등록하기</div>
                </div>
              ) : (
                //둘다 충족못한 경우
                <div className="impossible">
                  <div onClick={onClickAlertToggle3}>등록하기</div>
                </div>
              )}

              {alertModal1 && (
                <AlertModal
                  notice={textLength}
                  onClickConfirm={onClickAlert1}
                />
              )}
              {alertModal2 && (
                <AlertModal
                  notice={categoryNone}
                  onClickConfirm={onClickAlert2}
                />
              )}
              {alertModal3 && (
                <AlertModal notice={bothCase} onClickConfirm={onClickAlert3} />
              )}
            </Registration>
          </BottomFixed>
        </>
      )}
    </Container>
  );
}

export default UpdatePost;
